import { AnchorButton } from "@blueprintjs/core";
import { useAuthState } from "@package/ui-authentication";
import { useConfigState } from "@package/ui-config";

export function AppSwitcher() {
  const { app, applications } = useConfigState();
  const { authorizedApps } = useAuthState();

  const availableApplications = applications.filter((a) =>
    authorizedApps.includes(a.key),
  );

  if (availableApplications.length === 0) return null;

  return (
    <div className="flex flex-col gap-0.5">
      {availableApplications.map(({ display, key, uri, icon }) => (
        <AnchorButton
          key={key}
          minimal
          fill
          alignText="left"
          active={key === app}
          icon={icon}
          text={display}
          href={uri}
        />
      ))}
    </div>
  );
}
